import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  payments: [],
  loadingPayments: false,
  loadingStkPush: false,
  errorSendingStkPush: null,
  errorLoadingPayments: null,
  pagination: {},
  serverStatus: null,
};

export const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    setLoadingPayments: (state) => {
      state.loadingPayments = true;
      state.errorLoadingPayments = null;
    },
    setLoadingStkPush: (state) => {
      state.loadingStkPush = true;
      state.errorSendingStkPush = null;
    },
    setErrorSendingStkPush: (state, { payload }) => {
      state.loadingStkPush = false;
      state.errorSendingStkPush = payload;
    },
    setPayments: (state, { payload }) => {
      state.loadingPayments = false;
      state.payments = payload;
    },
    setStkPushSuccess: (state) => {
      state.loadingStkPush = false;
    },
    setErrorLoadingPayments: (state, { payload }) => {
      state.loadingPayments = false;
      state.errorLoadingPayments = payload;
    },
    setPaymentPagination: (state, { payload }) => {
      state.pagination = payload;
    },
    setServerResponseStatus(state, { payload }) {
      state.serverStatus = payload;
    },
  },
});

export const {
  setLoadingPayments,
  setPayments,
  setLoadingStkPush,
  setStkPushSuccess,
  setErrorSendingStkPush,
  setErrorLoadingPayments,
  setPaymentPagination,
  setServerResponseStatus,
} = paymentSlice.actions;

export default paymentSlice.reducer;
